/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { assetImages } from "constants";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";

import AgendaListFilter from "../Popups/AgendaListFilter";

import { getUpComingDates } from "helper/EventHelper/EventHelper";
import AgendaErrorMessageModal from "Components/Common/Modals/AgendaErrorMessageModal";

const AgendaList = ({ eventId, showTitle }) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const glowCount = [1, 2, 3];
  const dateOfToday = new Date().toISOString().split("T")[0];

  const [tagList, setTagList] = useState([]);

  const [dateTabArr, setDateTabArr] = useState([]);

  const [activeDate, setActiveDate] = useState(null); // State to track active date

  const [isLoading, setIsLoading] = useState(false);
  const [agendaList, setAgendaList] = useState([]);

  const [filterTags, setFilterTags] = useState([]);

  const [isEventMember, setIsEventMember] = useState(false);

  const [modalErrorMessage, setmodalErrorMessage] = useState("");

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get event details
  const getEventDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GUEST_EVENT_DETAILS_BY_ID + `/${eventId}`;

      // console.log("url of event details------>", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response of event details------>", response);

      if (response.status) {
        if (userInfo) {
          const isMemberExist = response.data.eventmemberids.includes(
            userInfo?._id
          );

          setIsEventMember(isMemberExist);
        } else {
          setIsEventMember(false);
        }
        const todayDate = new Date(dateOfToday);
        const fromDateObj = new Date(response.data.fromdate);
        const endDateObj = new Date(response.data.todate);

        if (todayDate >= fromDateObj && todayDate <= endDateObj) {
          getDateOfTabs(dateOfToday);
        } else {
          getDateOfTabs(response.data.fromdate);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get date list for tabs
  const getDateOfTabs = (dateValue) => {
    const dateArr = getUpComingDates(dateValue);
    setActiveDate(dateArr[0]);
    setDateTabArr(dateArr);
    if (eventId) {
      getAllEventAgenda(dateValue);
    }
  };

  //select date
  const dateSelectionHandler = (dateData) => {
    setActiveDate(dateData); // Set the clicked date as active
    getAllEventAgenda(dateData.fulldate);
  };

  //function for get all event members
  const getAllEventAgenda = async (agendaDate) => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_ALL_AGENDA +
        `?agendadate=${agendaDate}&event=${eventId}`;

      const response = await getData(requestUrl);

      setIsLoading(false);

      // console.log(response);

      if (response.status) {
        setAgendaList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const joinAgendaHanlder = async (agendaData) => {
    // console.log(agendaData);
    try {
      let userData = {
        agendadate: agendaData.date,
        starttime: agendaData.starttime,
        endtime: agendaData.endtime,
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_JOIN_AGENDA +
        `/${agendaData._id}?token=${token}`;

      const response = await putData(requestUrl, userData);

      console.log(response);

      if (response.status) {
        setmodalErrorMessage("");
        getAllEventAgenda(agendaData.date);
      } else {
        let errorModal = new bootstrap.Modal(
          document.getElementById("agenda_error_info_modal")
        );
        errorModal.show();
        setmodalErrorMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //resfresh
  const refreshHandler = () => {
    getEventDetails();
  };

  useEffect(() => {
    getEventDetails();
    if (token) {
      getAllTags();
    }
  }, []);

  return (
    <>
      {/* title section */}
      <div
        className={`page_heading mb-5 d-flex align-items-center ${
          showTitle ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {showTitle && (
          <h1 className="position-relative pb-4 text-uppercase">AGENDA</h1>
        )}
        <div className="d-flex align-items-center">
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary me-2"
            // data-bs-toggle="offcanvas"
            // data-bs-target="#offcanvasRight"
            onClick={refreshHandler}
          >
            <span className="material-icons-outlined text-white">refresh</span>
          </Link>
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasAgenda"
          >
            <span className="material-icons-outlined text-white">
              filter_list
            </span>
          </Link>
        </div>
      </div>

      {/* date tabs */}
      <div className="tab_links">
        <ul className="nav nav-tabs">
          {dateTabArr.map((dateData, index) => {
            return (
              <li className="nav-item" key={index}>
                <Link
                  to="#"
                  className={`nav-link ${
                    activeDate === dateData ? "active" : ""
                  }`}
                  onClick={() => {
                    dateSelectionHandler(dateData);
                  }}
                >
                  <span className="d-block text-primary text-uppercase fw-semibold fs-md text-center mb-1">
                    {dateData.day}
                  </span>
                  <span className="d-block text-primary-gray text-center fs-sm text-center">
                    {dateData.month} {dateData.year}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      {isLoading ? (
        <div className="agenda_outer">
          {glowCount.map((count, index) => {
            return (
              <div className="ageda_row d-flex mb-3" key={index}>
                <div className="agenda_left_time">
                  <h3 className="d-flex align-items-center gap-2">
                    <i className="material-icons-outlined text-pink col-2 placeholder placeholder-sm"></i>
                    <span className="fs-xl fw-bold text-primary col-12 placeholder placeholder-sm"></span>
                  </h3>
                </div>
                <div className="agenda_right_info">
                  <h3 className="fs-xl fw-bold text-primary text-uppercase mb-3 placeholder placeholder-sm"></h3>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span
                      className="d-block text-primary-gray placeholder placeholder-sm"
                      style={{ width: "80px" }}
                    ></span>
                    <span
                      className="d-block text-primary-gray placeholder placeholder-sm"
                      style={{ width: "80px" }}
                    ></span>
                  </div>

                  <div className="agenda_user_outer d-flex align-items-center gap-3 flex-wrap">
                    <div className="agenda_info_btn rounded-40 px-3 py-2 placeholder">
                      <span
                        className="d-block text-center fw-medium fs-sm position-relative placeholder"
                        style={{ width: "250px", height: "15px" }}
                      ></span>
                    </div>
                    <div className="agenda_info_users">
                      <div className="d-flex align-items-center list_style_none">
                        <span
                          className="d-block text-primary-gray placeholder placeholder-sm rounded-circle"
                          style={{ width: "30px", height: "30px" }}
                        ></span>
                        <span
                          className="d-block text-primary-gray placeholder placeholder-sm rounded-circle"
                          style={{ width: "30px", height: "30px" }}
                        ></span>
                        <span
                          className="d-block text-primary-gray placeholder placeholder-sm rounded-circle"
                          style={{ width: "30px", height: "30px" }}
                        ></span>
                        <span
                          className="d-block text-primary-gray placeholder placeholder-sm rounded-circle"
                          style={{ width: "30px", height: "30px" }}
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="agenda_outer">
          {agendaList.length > 0 ? (
            agendaList.map((agendaData, index) => {
              let existsAttandants = false;

              if (userInfo) {
                existsAttandants = agendaData.attandantsarr.some(
                  (obj) => obj._id.toString() === userInfo._id.toString()
                );
              }

              return (
                <div className="ageda_row d-flex mb-3" key={index}>
                  <div className="agenda_left_time">
                    <h3 className="d-flex align-items-center gap-2">
                      <i className="material-icons-outlined text-pink">
                        schedule
                      </i>
                      <span className="fs-xl fw-bold text-primary">
                        {agendaData.starttime}
                      </span>
                    </h3>
                    {isEventMember ? (
                      existsAttandants ? (
                        <Link
                          to="#"
                          className="btn outline h-auto px-3 py-2 text-nowrap d-flex align-items-center gap-2 mt-3 mb-3 mb-md-0"
                        >
                          <span className="d-block material-icons-outlined fs-md text-success">
                            check_circle
                          </span>
                          <span className="d-block">I will be attending</span>
                        </Link>
                      ) : (
                        <Link
                          onClick={() => joinAgendaHanlder(agendaData)}
                          to="#"
                          className="btn primary-btn h-auto px-3 py-2 text-nowrap d-flex align-items-center gap-2 mt-3 mb-3 mb-md-0"
                        >
                          <span className="d-block material-icons-outlined fs-md">
                            star
                          </span>
                          <span className="d-block">Interested</span>
                        </Link>
                      )
                    ) : null}
                    {/* <Link
                      to="#"
                      className="btn outline h-auto px-3 py-2 text-nowrap d-flex align-items-center gap-2 mt-3 mb-3 mb-md-0"
                    >
                      <span className="d-block material-icons-outlined fs-md text-success">
                        check_circle
                      </span>
                      <span className="d-block">I will be attending</span>
                    </Link> */}
                  </div>
                  <div className="agenda_right_info">
                    <h3 className="fs-xl fw-bold text-primary text-uppercase mb-3">
                      {agendaData.description}
                    </h3>
                    <ul className="list_style_none d-flex gap-3 flex-wrap mb-3">
                      <li className="d-flex align-items-center gap-1">
                        <i className="material-icons-outlined text-primary-gray">
                          timer
                        </i>
                        <span className="d-inline-block fs-lg text-primary-gray">
                          {agendaData.duration}
                        </span>
                      </li>
                      <li className="d-flex align-items-center gap-1">
                        <i className="material-icons-outlined text-primary-gray">
                          my_location
                        </i>
                        <span className="d-inline-block fs-lg text-primary-gray">
                          {agendaData.location}
                        </span>
                      </li>
                    </ul>
                    <div className="agenda_user_outer d-flex align-items-center gap-3 flex-wrap">
                      <div className="agenda_info_btn bg-pink rounded-40 px-3 py-2">
                        <span className="d-block text-center text-white fw-medium fs-sm position-relative">
                          {agendaData.eventname}
                        </span>
                      </div>
                      <div className="agenda_info_users">
                        <ul className="d-flex align-items-center list_style_none">
                          {agendaData.attandantsarr.map((member, index) => {
                            return (
                              <li
                                className="rounded-circle overflow-hidden"
                                key={index}
                              >
                                <img
                                  src={
                                    member.image == ""
                                      ? assetImages.defaultUser
                                      : url.SERVER_URL + member.image
                                  }
                                  alt=""
                                />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no_events text-center">
              {/* <span className="d-block text-center mb-2">
                <img src={assetImages.noSpeaker} alt="" />
              </span> */}
              <h5 className="text-primary fs-sm ">No agenda to show</h5>
            </div>
          )}
        </div>
      )}

      {/* filter */}
      <AgendaListFilter
        tagList={tagList}
        setfilterTags={setFilterTags}
        searchHandler={getDateOfTabs}
      />

      <AgendaErrorMessageModal
        modalMessage={modalErrorMessage}
        setModalMessage={setmodalErrorMessage}
      />
    </>
  );
};

export default AgendaList;
